// An order saved without a description stores a placeholder in the saver's language, like
// `<<Ingen beskrivning>>`, so it is recognised by its brackets alone.
const PLACEHOLDER = /^<+[^<>]*>+$/;

/** The order's description, or null when it has none or only the placeholder saved in its place. */
export const orderDescription = (description: string | null | undefined): string | null => {
	const trimmed = description?.trim();
	if (!trimmed || PLACEHOLDER.test(trimmed)) {
		return null;
	}
	return trimmed;
};
